import { View, Platform } from "react-native";
import Badge from "@/components/ui/Badge";

type EnvInfo = { label: string; tone: "amber" | "emerald" } | null;

function getEnvironment(): EnvInfo {
  if (Platform.OS !== "web" || typeof window === "undefined") return null;

  const hostname = window.location.hostname;

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return { label: "LOCAL", tone: "amber" };
  }

  if (hostname.includes("preview")) {
    return { label: "PREVIEW", tone: "emerald" };
  }

  return null;
}

const env = getEnvironment();

export function HeaderCenter() {
  if (!env) return null;

  return (
    <View style={{ flex: 1, alignItems: "center", justifyContent: "center" }}>
      <Badge text={env.label} tone={env.tone} />
    </View>
  );
}
